// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapPOIS_wrapper__3_ota","map_title_style":"MapPOIS_map_title_style__PZ0Vd"};